import React from 'react';
import {UserApp} from '../../../../Context/AuthProvider/AuthProviderActions';
import {SkeletonForm} from '../../../../Components/Form/SkeletonForm';
import {UserBaseForm} from './UserBaseForm';
import {addAlert} from '../../../../Context/AlertProvider/AlertProviderActions';
import {useAlertDispatcherState} from '../../../../Context/AlertProvider/AlertProvider';
import {useLocation, useParams} from 'react-router-dom';

interface ViewProps {
    user: UserApp,
    keys: number[],
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    isLoading: boolean,
    isLoadingKeys: boolean,
    isLoadingUser: boolean,
    saveDiazarUserFunc: (updateUser: UserApp) => void,
    setUser: React.Dispatch<React.SetStateAction<UserApp>>,
}

export const AddOrEditTabElement:React.FunctionComponent<ViewProps> = (props) => {
    const {user, keys, isLoading, setIsLoading, saveDiazarUserFunc, setUser, isLoadingUser, isLoadingKeys} = props;
    const [showFrom, setShowFrom] = React.useState<boolean>(false);

    const { userID } = useParams();

    const location = useLocation();
    const currentPath = React.useMemo(() => {
        // Se elimina el primer elemento vacío y se obtiene el siguiente segmento
        const parts = location.pathname.split('/').filter(Boolean);
        return parts[0] || '';
    }, [location.pathname]);

    React.useEffect(()=>{
        if( isLoadingUser && isLoadingKeys ){
            setTimeout( ()=>{
                setShowFrom(true);
            }, 400);
        }
    }, [isLoadingKeys, isLoadingUser]);

    const hasKeys = React.useMemo( ()=>{
        return !(showFrom && (user.ids > 0 || keys.length > 0));
    }, [keys, showFrom, user.ids] );

    const showSkeletonsBaseInfo = React.useMemo(()=>{
        return  isLoading || hasKeys;
    }, [hasKeys, isLoading]);

    if (showSkeletonsBaseInfo){
        return <SkeletonForm largeInputs={0} middleInputs={3} buttons={2}  />;
    }

    return(
        <UserBaseForm
            user={ user }
            keys={ keys }
            setIsLoading={ setIsLoading }
            saveDiazarUserFunc={ saveDiazarUserFunc }
            setUser={ setUser }
            disableAll={hasKeys}
        />
    );
};
